import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Authorize, CustomLoginService } from '@privatelib/ngx18-authz-dev';
import { CVANotificationService } from '../../../services/cva-notification/cva-notification.service';
import { NotificationClassEnum } from '../../../models/notification-class.enum';
import { ROUTE_CONSTANTS } from '../../../util/route.constants';
import { Router } from '@angular/router';
import { CVA_CONSTANTS } from '../../../util/constants';

export interface UserDetails {
  id: string,
  email: string,
  firstName: string,
  lastName: string,
  providerId: string
}

export enum ENUM_PASSWORD_VISIBLE {
  NEW = 'new',
  OLD = 'old',
  C_NEW = 'c_new'
}

@Component({
    standalone: false,
    selector: 'cva-change-password',
    templateUrl: './change-password.component.html',
    styleUrl: './change-password.component.scss',
    
})


export class ChangePasswordComponent implements OnInit {
  userDetails!: UserDetails;
  afterChangePasswordSuccess: boolean = false;
  changePasswordForm!: FormGroup;
  oldPasswordVisible: boolean = true;
  newPasswordVisible: boolean = true;
  cNewPasswordVisible: boolean = true;
  isPasswordMatched: boolean = true;

  constructor(private readonly authorize: Authorize,
    private readonly customLoginService: CustomLoginService,
    private readonly router: Router,
    private readonly cvaNotificationService: CVANotificationService) {
  }

  ngOnInit() {
    console.log("Change password page loaded");
    this.userDetails = this.authorize.getUserDetails();
    this.changePasswordForm = new FormGroup({
      email: new FormControl({ value: this.userDetails.email, disabled: true }),
      old_password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      new_password: new FormControl('', [Validators.required, Validators.minLength(8)]),
      c_new_password: new FormControl('', [Validators.required, Validators.minLength(8)])
    })
  }

  submitForm() {
    if (!this.changePasswordForm.valid) {
      return;
    }
    if (!this.validateConfirmPassword()) {
      this.cvaNotificationService.showNotification(
        "Passwords does not match.",
        NotificationClassEnum.ERROR
      )
      return;
    }

    const formData = this.changePasswordForm.value;
    if (formData.old_password === formData.new_password) {
      this.cvaNotificationService.showNotification(
        "New password cannot be same as old password.",
        NotificationClassEnum.ERROR
      )
      return;
    }
    const userDetails = {
      userId: this.userDetails.id,
      new_password: formData.new_password,
      old_password: formData.old_password
    };
    console.log("Change password form submitted");
    this.customLoginService.changePassword(userDetails).subscribe({
      // eslint-disable-next-line  @typescript-eslint/no-explicit-any
      next: () => {
        this.customLoginService.logout().subscribe(() => {
          this.afterChangePasswordSuccess = true;
          sessionStorage.clear();
        });
      },
      error: (err) => {
        console.log("Error while changing the password");
        this.cvaNotificationService.showNotification(
          err?.message ?? CVA_CONSTANTS.MESSAGE.CHANGE_PASSWORD_ERROR,
          NotificationClassEnum.ERROR
        )
      }
    })
  }

  isPasswordValid() {
    return this.changePasswordForm.get('new_password')?.valid;
  }

  setInputType(passwordVisible: string) {
    if (passwordVisible === ENUM_PASSWORD_VISIBLE.NEW) {
      this.newPasswordVisible = !this.newPasswordVisible;
    } else if (passwordVisible === ENUM_PASSWORD_VISIBLE.OLD) {
      this.oldPasswordVisible = !this.oldPasswordVisible;
    }
    else if (passwordVisible === ENUM_PASSWORD_VISIBLE.C_NEW) {
      this.cNewPasswordVisible = !this.cNewPasswordVisible;
    }
  }

  gotoLogin() {
    this.router.navigate([ROUTE_CONSTANTS.LOGIN]);
  }

  validateConfirmPassword() {
    const password = this.changePasswordForm.get('new_password');
    const confirmPassword = this.changePasswordForm.get('c_new_password');

    const matched = password && confirmPassword && password.value === confirmPassword.value
    this.isPasswordMatched = Boolean(matched);
    return matched
  }

  //This function is just to avoid SONAR warning
  doNothing() {
    console.log("Do nothing");
  }
}
